/* ============================================================
   ToTheLove — PDP : Avis avant/après (galerie)
   ------------------------------------------------------------
   Custom element <ttl-ba-reviews>. Réinit auto au shopify:section:load.
   Scoping strict via [data-ttl-bar*].

   Unique rôle : drag-to-scroll souris sur la piste de cartes (les cartes
   ne sont pas cliquables → pas de gestion clic/play comme l'UGC).
   - on ne capture le pointeur qu'APRÈS le seuil de glissement (sinon on
     volerait d'éventuels clics / on bloquerait la sélection de texte) ;
   - le snap est coupé pendant le glissement (CSS via [data-ttl-grabbing]),
     il se ré-engage au relâchement ;
   - tactile : scroll natif.
   ============================================================ */
(function () {
  if (customElements.get('ttl-ba-reviews')) return;

  var DRAG_THRESHOLD = 6;

  class TtlBaReviews extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.track = this.querySelector('[data-ttl-bar-track]');
      if (this.track) this._bindDrag();
    }

    _bindDrag() {
      var track = this.track;
      var down = false;
      var isMouse = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      track.addEventListener('pointerdown', function (e) {
        isMouse = e.pointerType === 'mouse';
        if (!isMouse) return; // tactile : scroll natif
        down = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!down || !isMouse) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
          moved = true;
          track.setAttribute('data-ttl-grabbing', '');
          try {
            track.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
        if (moved) {
          e.preventDefault();
          track.scrollLeft = startScroll - dx;
        }
      });

      function endDrag(e) {
        if (!down) return;
        down = false;
        track.removeAttribute('data-ttl-grabbing');
        if (e && e.pointerId != null) {
          try {
            track.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    }
  }

  customElements.define('ttl-ba-reviews', TtlBaReviews);
})();
